<template>
  <div class="steps">
    <span class="points">
      <flow-step
        v-for="(name, index) in stepNames"
        :key="name"
        :stepNumber="index + 1"
        :stepName="$t(name)"
        :active="currentStep == index + 1 && currentStep !== 7"
        :ready="visitedStepsCnt >= index + 1 && currentStep !== index + 1 && currentStep !== 7"
        @clicked="onClickStepButton"
      />
    </span>
    <two-way-controls
      :forwardActive="allowNext"
      :backHidden="currentStep === MIN_STEP || currentStep === 7"
      :forwardHidden="currentStep === maxStep || currentStep === 7"
      :backTitle="$t('newProject.previous')"
      :forwardTitle="$t('newProject.next')"
      @click:back="navigatePreviousStep"
      @click:forward="navigateNextStep"
    />
  </div>
</template>

<script>
import FlowStep from '@/components/common/FlowStep.vue';
import TwoWayControls from '@/components/common/TwoWayControls.vue';

export default {
  name: 'NewProjectStepper',
  components: {
    FlowStep,
    TwoWayControls,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    filledStepsCnt: {
      type: Number,
      required: true,
    },
    visitedStepsCnt: {
      type: Number,
      required: true,
    },
    allowNext: {
      type: Boolean,
      required: true,
    },
    stepNames: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      MIN_STEP: 1,
    };
  },
  computed: {
    maxStep() {
      return this.stepNames.length;
    },
  },
  methods: {
    navigatePreviousStep() {
      const newStep = this.currentStep - 1;
      if (newStep >= this.MIN_STEP) {
        this.fireClickEvent(newStep);
      }
    },
    navigateNextStep() {
      const newStep = this.currentStep + 1;
      if (newStep <= this.maxStep) {
        this.fireClickEvent(newStep);
      }
    },
    onClickStepButton(stepToGo) {
      if (this.visitedStepsCnt >= stepToGo) {
        this.fireClickEvent(stepToGo);
      }
    },
    fireClickEvent(stepToGo) {
      this.$emit('clicked', stepToGo);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.steps {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;

  padding-left: rem(120);
  padding-right: rem(120);
  padding-top: $space-2;
  background-color: var(--bg-primary);
  box-shadow: 0 0 rem(14) 0 rgba(14, 31, 51, 0.13);
  position: fixed;
  bottom: 0;
  height: rem(77);
  width: 100%;
  min-width: rem(1240);
}

.two-way-controls {
  float: right;
  padding-top: rem(7);
  margin-top: rem(7);
}
</style>
